/**
 * A factory function to pull a FeatureFlagWebClient from a window property.
 * @param objectPath the window property from which to pull the FeatureFlagWebClient
 * @returns the FeatureFlagWebClient
 * @deprecated to be removed in a future version
 */
export function fromWindowProperty(objectPath) {
    const properties = Array.isArray(objectPath)
        ? objectPath
        : objectPath.split(".");
    const clientObject = properties.reduce((prev, currPath) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const currObj = prev[currPath];
        if (!currObj) {
            throw new Error(`${currPath} property not initialized for the full path ${objectPath} in window object`);
        }
        return prev[currPath];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, window);
    // doing null check instead of constructor name check because
    // webpack could minify the class name and implementation could change
    if (clientObject == undefined || clientObject == null) {
        throw new Error(`The object '${clientObject.constructor.name}' from the path ${objectPath} is null or undefined`);
    }
    return clientObject;
}
//# sourceMappingURL=feature-flag-web-client.js.map